var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReportShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1502_17)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.775 3.54941L9.44727 0.32832C9.24492 0.131445 8.96875 0.0193359 8.68438 0.0193359L2.41719 0.00292969C1.65703 0.00292969 1.03906 0.61543 1.03906 1.37012V12.6303C1.03906 13.3713 1.67617 14.0002 2.43086 14.0002H11.7004C12.4414 14.0002 13.043 13.385 13.043 12.6275V4.20293C13.043 3.94863 12.9473 3.71621 12.775 3.54941ZM9.43359 1.8377L11.1535 3.5002H9.73164C9.57305 3.5002 9.43359 3.37715 9.43359 3.2377V1.8377ZM11.7004 12.9064H2.43086C2.27773 12.9064 2.13281 12.7725 2.13281 12.6275V1.37012C2.13281 1.2252 2.2668 1.09668 2.41719 1.09668L8.33984 1.11309V3.2377C8.33984 3.98418 8.96328 4.59395 9.73164 4.59395H11.9492V12.6275C11.9492 12.7643 11.8562 12.9064 11.7004 12.9064Z",
    fill: "#B99750"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.41797 7.30078C3.41797 7.60156 3.66406 7.84766 3.96484 7.84766H8.75C9.05078 7.84766 9.29688 7.60156 9.29688 7.30078C9.29688 7 9.05078 6.75391 8.75 6.75391H3.96484C3.66406 6.75391 3.41797 7 3.41797 7.30078ZM3.9375 5.66016H7.10938C7.41016 5.66016 7.65625 5.41406 7.65625 5.11328C7.65625 4.8125 7.41016 4.56641 7.10938 4.56641H3.9375C3.63672 4.56641 3.39062 4.8125 3.39062 5.11328C3.39062 5.41406 3.63672 5.66016 3.9375 5.66016ZM10.1172 8.94141H3.96484C3.66406 8.94141 3.41797 9.1875 3.41797 9.48828C3.41797 9.78906 3.66406 10.0352 3.96484 10.0352H10.1172C10.418 10.0352 10.6641 9.78906 10.6641 9.48828C10.6641 9.1875 10.418 8.94141 10.1172 8.94141Z",
    fill: "#B99750"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1502_17"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportShare);
export default __webpack_public_path__ + "static/media/report-share.cbc2803616f991d13e4443c786606875.svg";
export { ForwardRef as ReactComponent };